module.exports = __webpack_public_path__ + "static/img/about18.fa4a3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about18.png
// module id = 8zmt
// module chunks = 1